import { ScmIntegrationsApi, scmIntegrationsApiRef, ScmAuth } from '@backstage/integration-react';
import {
  AnyApiFactory,
  configApiRef,
  createApiFactory,
  discoveryApiRef,
  errorApiRef,
  fetchApiRef,
  identityApiRef,
} from '@backstage/core-plugin-api';
import { VisitsWebStorageApi, visitsApiRef } from '@backstage/plugin-home';
import { RecordingVisitsApi } from './components/home/homeVisits';

export const apis: AnyApiFactory[] = [
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),
  ScmAuth.createDefaultApiFactory(),
  // Stores page visits per user in browser local storage ("Recently Visited"), and reports each
  // visit to the home-visits backend, which ranks pages across all users ("Top Visited").
  createApiFactory({
    api: visitsApiRef,
    deps: {
      identityApi: identityApiRef,
      errorApi: errorApiRef,
      discoveryApi: discoveryApiRef,
      fetchApi: fetchApiRef,
    },
    factory: ({ identityApi, errorApi, discoveryApi, fetchApi }) =>
      new RecordingVisitsApi(
        VisitsWebStorageApi.create({ identityApi, errorApi }),
        discoveryApi,
        fetchApi,
      ),
  }),
];
